import { useEffect, useState } from "react";

type TimeoutOptions = {
  disabled?: boolean;
  intervalMs?: number;
};

export default function useOnTimeout(
  timeout: number,
  callback: () => any,
  options?: TimeoutOptions
) {
  const [counter, setCounter] = useState(timeout);
  const [callbackCalled, setCallbackCalled] = useState(false);
  const isDisabled = options?.disabled ?? (process.env.NODE_ENV === "test" ? true : false);
  const intervalMs = options?.intervalMs ?? 1000;

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;

    if (isDisabled) {
      return () => undefined;
    }

    if (counter > 0) {
      timeout = setTimeout(() => setCounter(counter - 1), intervalMs);
    } else if (!callbackCalled) {
      callback();
      setCallbackCalled(true);
    }

    return () => clearTimeout(timeout);
  }, [callback, callbackCalled, counter, intervalMs, isDisabled]);

  return counter;
}
